export function toIntlFormattedValue(numberValue) {
  /**
   * 123,456.2 is not a number like value
   * so it has to be transform to 123456.2
   */
  const intlNumber = new Intl.NumberFormat().format(numberValue);

  if (Number.isNaN(Number(numberValue))) {
    return 0;
  }
  if (numberValue === "") {
    return "";
  }
  return intlNumber;
}

export function getNumber(value) {
  const numberValue = parseInt(getNumberString(value));

  return numberValue;
}

export function getNumberString(value) {
  const numberValue = value.replace(/,/g, "");

  return numberValue;
}
